import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from '../trpc.js';
import type { MenuItem } from '../ui/Menu.js';
import { useToast } from '../ui/Toast.js';

/**
 * "Google Drive: connected · Disconnect" in the account menu, while this
 * person has let the app create sheets in their Drive. Nothing otherwise: the
 * first export asks.
 */
export function useDriveMenuItems(signedIn: boolean): MenuItem[] {
  const trpc = useTRPC();
  const toast = useToast();
  const queryClient = useQueryClient();
  const status = useQuery({ ...trpc.exports.driveStatus.queryOptions(), enabled: signedIn });
  const disconnect = useMutation(
    trpc.exports.disconnectDrive.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: trpc.exports.driveStatus.queryKey() });
        toast('Google Drive disconnected. Sheets already made stay in your Drive.', {
          tone: 'info',
        });
      },
      onError: (error) => toast(error.message),
    }),
  );

  if (status.data?.status !== 'connected') return [];
  return [
    {
      label: 'Google Drive: connected · Disconnect',
      disabled: disconnect.isPending,
      onSelect: () => disconnect.mutate(),
    },
  ];
}
